import {
  Invitations,
  Notifications,
  UserForm,
  Compare,
} from '@prometheus/features';
import {
  acceptInvitation,
  declineInvitation,
  getInvitations,
  getInvitationsCount,
  getNotifications,
  updateNotifications,
  signOutUser,
  switchTenant,
  getNotificationsUnread,
} from '@prometheus/redux';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import SideNavigation from '../SideNavigation';
import {
  ContentContainer,
  LayoutContainer,
  NavigationSubContainer,
  PageContainer,
  UserActionsContainer,
} from './AppLayout.styles';
import { UserDTO, AppState } from '@prometheus/types';

export const AppLayout: FC<{
  modulesSideNavigation: any;
  enabledModuleIds: string[];
}> = ({ modulesSideNavigation, enabledModuleIds }) => {
  const currentUser = useSelector<AppState, UserDTO>(
    (state: any) => state.user.data
  );
  return (
    <LayoutContainer>
      <SideNavigation
        list={modulesSideNavigation}
        enabledModuleIds={enabledModuleIds}
      />

      <ContentContainer>
        <NavigationSubContainer>
          {currentUser?.email && (
            <>
              <Breadcrumbs />
              <UserActionsContainer>
                <Compare />
                <Notifications
                  getNotifications={getNotifications}
                  updateNotifications={updateNotifications}
                  getNotificationsUnread={getNotificationsUnread}
                />
                <Invitations
                  getList={getInvitations}
                  accept={acceptInvitation}
                  decline={declineInvitation}
                  getCount={getInvitationsCount}
                />
                <UserForm
                  showMenu
                  onLogout={signOutUser}
                  onContextSwitch={switchTenant}
                />
              </UserActionsContainer>
            </>
          )}
        </NavigationSubContainer>

        <PageContainer>
          <Outlet />
        </PageContainer>
      </ContentContainer>
    </LayoutContainer>
  );
};
